export const generatedSidecarPromotionLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-runtime-sidecar-promotion-ledger",
  "operatingRule": "Runtime science artifacts must be generated outside the browser, validated against sidecar contracts, and independently compared where required before they can promote trajectory, event-window, or optimization claims.",
  "contractHash": "sha256-7c4a24f9f81457204cb8d56bf3773f1b757ad96b02af5c4cedade5f84a61a81f",
  "contractCount": 5,
  "reportCount": 3,
  "validReportCount": 3,
  "invalidReportCount": 0,
  "validationCount": 3,
  "submittedArtifactCount": 3,
  "promotedCount": 3,
  "promotedContractCount": 2,
  "blockedValidationCount": 0,
  "promotedContractIds": [
    "openmdao-dymos-optimization-v1",
    "spice-gf-event-window-v1"
  ],
  "promotedArtifactIds": [
    "openmdao-dymos-runtime-moon-logistics-beta-optimization",
    "spice-gf-runtime-mercury-clear-link-22deg-2025",
    "spice-gf-runtime-mercury-clear-link-nonzero-window-proof-2025-08"
  ],
  "promotedDomainCounts": {
    "optimization-and-sensitivity": 1,
    "ephemeris-event-windows": 2
  },
  "contractPromotionGapCount": 3,
  "promotionAllowed": false,
  "promotionState": "partial-runtime-promotion-contract-gaps",
  "blockers": [
    "3 sidecar contract(s) still lack promoted runtime artifacts."
  ],
  "reportSummaries": [
    {
      "sourcePath": "evidence/sidecar-intake-reports/openmdao-dymos-runtime-intake-report.json",
      "reportHash": "sha256-5728b108e97d4cf104a3d937f7fefceedb1eaa8827c1528a8770cf1fd895345d",
      "valid": true,
      "submittedArtifactCount": 1,
      "promotedCount": 1,
      "blockedCount": 0,
      "blockers": []
    },
    {
      "sourcePath": "evidence/sidecar-intake-reports/spice-gf-clear-link-22deg-2025-intake-report.json",
      "reportHash": "sha256-fc9d58bfdc8c766b46ee27e05188649c9c60a2c88799c879c4bec06ebba717cb",
      "valid": true,
      "submittedArtifactCount": 1,
      "promotedCount": 1,
      "blockedCount": 0,
      "blockers": []
    },
    {
      "sourcePath": "evidence/sidecar-intake-reports/spice-gf-runtime-intake-report.json",
      "reportHash": "sha256-7d837f800c33851d36e7f8e2974036603e22cd4cd16c8a05296ded824c11e908",
      "valid": true,
      "submittedArtifactCount": 1,
      "promotedCount": 1,
      "blockedCount": 0,
      "blockers": []
    }
  ],
  "contractPromotionGaps": [
    {
      "contractId": "orekit-propagation-v1",
      "tool": "Orekit",
      "domain": "trajectory-propagation",
      "requiredFields": [
        "toolVersion",
        "runAt",
        "scenarioId",
        "dataContext",
        "frames",
        "timeScale",
        "forceModel",
        "events",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison",
        "limitations",
        "validationStatus"
      ],
      "sourceIds": [
        "orekit"
      ],
      "promotionRule": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
      "contractHash": "sha256-f58a64812173f0a91a8d0ac4b3eefed3524179912540073c21537ea9b81f26ff"
    },
    {
      "contractId": "gmat-transfer-v1",
      "tool": "NASA GMAT",
      "domain": "mission-design-transfer",
      "requiredFields": [
        "gmatVersion",
        "runAt",
        "scenarioId",
        "scriptHash",
        "epoch",
        "forceModel",
        "optimizer",
        "trajectorySummary",
        "constraintSummary",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison",
        "limitations",
        "validationStatus"
      ],
      "sourceIds": [
        "gmat"
      ],
      "promotionRule": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
      "contractHash": "sha256-d0f211a4a572e25c1aa4305535f78823bcbbab1f467a4696563d813e6e202cfd"
    },
    {
      "contractId": "tudat-transfer-v1",
      "tool": "Tudat",
      "domain": "cross-tool-trajectory-validation",
      "requiredFields": [
        "toolVersion",
        "runAt",
        "scenarioId",
        "bodySettings",
        "integrator",
        "propagatorSettings",
        "trajectorySummary",
        "residualSummary",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison",
        "limitations",
        "validationStatus"
      ],
      "sourceIds": [
        "tudat"
      ],
      "promotionRule": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
      "contractHash": "sha256-ea04034158afb1f40150c168e50717cf068016c88cdd8f0187883058e38bbabb"
    }
  ],
  "validations": [
    {
      "reportPath": "evidence/sidecar-intake-reports/openmdao-dymos-runtime-intake-report.json",
      "reportHash": "sha256-5728b108e97d4cf104a3d937f7fefceedb1eaa8827c1528a8770cf1fd895345d",
      "artifactId": "openmdao-dymos-runtime-moon-logistics-beta-optimization",
      "contractId": "openmdao-dymos-optimization-v1",
      "tool": "OpenMDAO/Dymos",
      "domain": "optimization-and-sensitivity",
      "scenarioId": "moon-first",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "artifactState": "runtime-generated",
      "validationStatus": "passed",
      "artifactHash": "sha256-4ae76fa49e39336042cd1e76f36873c538a5a60e80e5194289d5a1daf909b896",
      "validationHash": "sha256-c407d3e66feefebc869d40e3bfa3730a4fc2c7615e740449f2da4010e443ddd7",
      "blockers": [],
      "nextAction": "Artifact may be reviewed for claim promotion.",
      "promotionRecordHash": "sha256-209bb8d8d2f9a5084db3d8cc531f2417f3838c3b66c0f8246f72737808ff5426"
    },
    {
      "reportPath": "evidence/sidecar-intake-reports/spice-gf-clear-link-22deg-2025-intake-report.json",
      "reportHash": "sha256-fc9d58bfdc8c766b46ee27e05188649c9c60a2c88799c879c4bec06ebba717cb",
      "artifactId": "spice-gf-runtime-mercury-clear-link-22deg-2025",
      "contractId": "spice-gf-event-window-v1",
      "tool": "NASA NAIF SPICE Geometry Finder",
      "domain": "ephemeris-event-windows",
      "scenarioId": "mercury-clear-link-22deg-2025",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "artifactState": "runtime-generated",
      "validationStatus": "passed",
      "artifactHash": "sha256-6bba7e3d4ceef9f865c3cf9acee8fe83bd68bf0d803fafb7b852530cffcad8f0",
      "validationHash": "sha256-b821956c87d700973de4b729e8521d88236ca7879136d54efa0e4efa32686d3c",
      "blockers": [],
      "nextAction": "Artifact may be reviewed for claim promotion.",
      "promotionRecordHash": "sha256-dea6f6af58db15aec36bf539fdc456684a754a4bee7f470151a45970da8cc9ed"
    },
    {
      "reportPath": "evidence/sidecar-intake-reports/spice-gf-runtime-intake-report.json",
      "reportHash": "sha256-7d837f800c33851d36e7f8e2974036603e22cd4cd16c8a05296ded824c11e908",
      "artifactId": "spice-gf-runtime-mercury-clear-link-nonzero-window-proof-2025-08",
      "contractId": "spice-gf-event-window-v1",
      "tool": "NASA NAIF SPICE Geometry Finder",
      "domain": "ephemeris-event-windows",
      "scenarioId": "mercury-clear-link-nonzero-window-proof-2025-08",
      "promotionAllowed": true,
      "fieldCoveragePercent": 100,
      "artifactState": "runtime-generated",
      "validationStatus": "passed",
      "artifactHash": "sha256-ac59ad01e58f7d228c7cc412dcadaa40000f1e249a68c99ab6496dc17cccabf1",
      "validationHash": "sha256-0e447e7bc3b17a578af3a924a9419b42ea2bf2c23ccd6127e6bf9fd0a5a4528c",
      "blockers": [],
      "nextAction": "Artifact may be reviewed for claim promotion.",
      "promotionRecordHash": "sha256-722c0ad15b6f97df298901e69bca6e14ca19e29ab6b64de67692cb6496e846f2"
    }
  ],
  "nextAction": "Generate SPICE/Orekit/GMAT/Tudat/OpenMDAO sidecar artifacts and place intake reports in evidence/sidecar-intake-reports.",
  "ledgerHash": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6"
}
;
